<mat-card
  appearance="outlined"
  class="pass-card"
  [class]="{
    'pass-card__paid': pass.purchased,
    'pass-card__redeemed': isRedeemed,
    'pass-card__disabled': pass.disabled,
    'pass-card__processing': pass.processing
  }"
>
  <div class="pass-card__pass-type">
    <picture class="pass-card__pass-type__default" *ngIf="!havePass">
      <img src="/shared/svg/promo-code-withoutpass.svg" alt="Pass image icon" />
    </picture>
    <picture class="pass-card__pass-type__promo-code" *ngIf="havePass">
      <img
        src="/shared/img/tournaments/pass/background.svg"
        alt="Pass image with promo code icon"
      />
    </picture>
  </div>

  <!-- Stamps for paid and redeemed states of pass -->
  <div class="pass-card__stamp" *ngIf="pass.purchased || isRedeemed">
    <!-- Paid Mask-->
    <div class="pass-card__paid__stamp" *ngIf="pass.purchased && !isRedeemed">
      <picture class="pass-card__paid__stamp__picture">
        <img src="/shared/svg/stamp_paid.svg" alt="Pass Paid Image" />
      </picture>
    </div>

    <!-- Redeemed Mask -->
    <div class="pass-card__redeemed__stamp" *ngIf="isRedeemed">
      <picture class="pass-card__redeemed__stamp__picture">
        <img src="/shared/svg/redeemed.svg" alt="Pass Redeemed Image" />
        <caption>
          {{
            redeemedDate | date: 'MMM d, y'
          }}
        </caption>
      </picture>
    </div>
  </div>

  <div class="pass-card__root">
    <!-- Pass Header -->
    <div class="pass-card__header">
      <h2
        class="pass-card__header__title clear-browser-styles mat-title-medium"
      >
        {{ pass.name }} Pass
      </h2>
      <div class="pass-card__header__discount" *ngIf="discountPercent">
        <span class="pass-card__header__discount-value">
          {{ discountPercent }}
        </span>
      </div>
    </div>

    <!-- Pass Body -->
    <div class="pass-card__body">
      <p class="pass-card__body__price clear-browser-styles">
        {{ pass.price.price | currency: 'USD' : 'symbol' }} USD
      </p>
      <p class="pass-card__body__description clear-browser-styles">
        Valid for {{ isUnlimited ? 'unlimited' : pass.entries }}
        {{ pass.entries > 1 ? 'entries' : 'entry' }}
      </p>
      <p
        class="pass-card__body__purchased clear-browser-styles"
        *ngIf="pass?.purchased"
      >
        Purchased on {{ pass.createdAt | date: 'MMM d, y' }}
      </p>
    </div>

    <!-- Pass Footer (include primary action)-->
    <div class="pass-card__footer">
      <button
        mat-flat-button
        color="primary"
        class="pass-card__footer__primary-action animation__glow"
        [fzProcessing]="pass.processing || false"
        [disabled]="pass.processing || pass.disabled || false"
        (click)="onPrimaryAction($event)"
      >
        {{ primaryActionText }}
      </button>
    </div>
  </div>
  <!-- Pass Promo Code -->
  <button
    mat-stroked-button
    color="primary"
    class="pass-card__share-promo-code"
    matTooltip="Share your promo code '{{ promoCode }}' with your friends"
    *ngIf="promoCode"
    (click)="onSharePromoCode($event)"
  >
    <div class="button-content">
      <span class="clear-browser-styles">Code: {{ promoCode }}</span>
      <mat-icon>share</mat-icon>
    </div>
  </button>
</mat-card>

<!-- Template component for paid -->
<ng-template #paidTpl></ng-template>

<!-- Template for redeemed -->
<ng-template #redeemedTpl> </ng-template>
